export type TAnchorPosition = "auto"|"below"|"above"|"left"|"right"|"fixed"
export type TAnchorWidth = "auto"|"match"|"min-match"
export type TAnchorProps = {
    follow?:string
    width?:TAnchorWidth
    anchorPosition?:TAnchorPosition,
    position?:{x:number,y:number}       // anchorposition = fixed
}

export default class AnchorHelepr {
    static anchor(element:HTMLDivElement, target:Element, options:TAnchorProps) {
        const rSelf = element.getBoundingClientRect(), rTarget = target.getBoundingClientRect()

        switch(options.width) {
        case "match":
            if (rSelf.width!=rTarget.width) element.style.setProperty("width", rTarget.width+"px")
            break;
        case "min-match":
            if (rSelf.width<rTarget.width) element.style.setProperty("min-width", rTarget.width+"px")
            break;
        }

        if (options.anchorPosition=="right" || options.anchorPosition=="left") return this.hAnchor(element, rSelf, rTarget)
        else return this.vAnchor(element, rSelf, rTarget)
    }
    static vAnchor(element:HTMLDivElement, rSelf:DOMRect, rTarget:DOMRect) {
        var anchor = "vert "

        if (rTarget.bottom + rSelf.height > window.innerHeight && rTarget.top - rSelf.height>0) {
            element.style.removeProperty("top")
            element.style.setProperty("bottom", "anchor(top)")
            anchor += "above"
        }else{
            element.style.removeProperty("bottom")
            element.style.setProperty("top", "anchor(bottom)")
            anchor += "below"
        }

        if (rTarget.left+rSelf.width+100>=window.innerWidth) {
            element.style.removeProperty("left")
            element.style.setProperty("right", "anchor(right)")
            anchor += " right"
        }
        else {
            element.style.removeProperty("right")
            element.style.setProperty("left", "anchor(left)")
            anchor += " left"
        }

        return anchor
    }
    static hAnchor(element:HTMLDivElement, rSelf:DOMRect, rTarget:DOMRect) {
        var anchor = "horz "
        if (rTarget.right + rSelf.width > window.innerWidth) {
            anchor += "left"
            element.style.removeProperty("left")
            element.style.setProperty("right", "anchor(left)")
        }else{
            anchor += "right"
            element.style.removeProperty("right")
            element.style.setProperty("left", "anchor(right)")
        }
        if (rTarget.top+rSelf.height>window.innerHeight) {
            element.style.removeProperty("top")
            element.style.setProperty("bottom", "anchor(bottom)")
        }
        else {
            element.style.removeProperty("bottom")
            element.style.setProperty("top", "anchor(top)")
        }
        return anchor
    }
}